import type { TranscriptPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptFetched';
import type { TranscriptTurnPayload } from '@Application/Beneficiaries/Transcripts/Actions/transcriptTurnsFetched';

/**
 * `PATCH …/transcript/turns/:turn` answers `{ turn, transcript }`, never the turn alone (§5.3): a
 * revision resets `reviewedAt`/`reviewedBy` and may bump `revisedTurnCount` on the server, and both
 * branches of the store must move together or the screen keeps showing a review that no longer holds.
 */
export type TranscriptTurnRevisedPayload = {
	readonly turn: TranscriptTurnPayload;
	readonly transcript: TranscriptPayload;
};

export type TranscriptTurnRevisedAction = {
	type: 'TRANSCRIPT_TURN_REVISED';
	payload: TranscriptTurnRevisedPayload;
	interviewId: number;
};

export default (payload: TranscriptTurnRevisedPayload, interviewId: number): TranscriptTurnRevisedAction => ({
	type: 'TRANSCRIPT_TURN_REVISED',
	payload,
	interviewId,
});
